import { createContext, FunctionalComponent } from 'preact';
import { useCallback } from 'preact/hooks';
import { useDialog } from '@accedo/ctv-ui-dialog';
import { noop } from '@accedo/general-utils';
import GenericPopupDialog, { GenericPopupDialogProps } from '##/components/Dialogs/GenericPopupDialog';

type showPopupArgs = Omit<GenericPopupDialogProps, 'id'>;

type GenericPopupContextType = {
  showPopup: (popupArgs: showPopupArgs) => void;
  closePopup: () => void;
};

export const GenericPopupContext = createContext<GenericPopupContextType>({ showPopup: noop, closePopup: noop });

const GenericPopupProvider: FunctionalComponent = ({ children }) => {
  const { open, close } = useDialog();

  const showPopup = useCallback((popupArgs: showPopupArgs) => {
    close(); // Close any existing dialogs before opening a new one

    const errorDialog = <GenericPopupDialog {...popupArgs} id="elevate-generic-error-dialog" />;

    open(errorDialog);
  }, []);

  return (
    <GenericPopupContext.Provider value={{ showPopup, closePopup: close }}>{children}</GenericPopupContext.Provider>
  );
};

export default GenericPopupProvider;
